import * as Yup from "yup";

export const bankDetailSchema = Yup.object({
  accountName: Yup.string()
    .trim()
    .required("Account name is required")
    .max(255, "Too long"),
  accountNumber: Yup.string()
    .trim()
    .required("Account number is required")
    .matches(/^\d{9,18}$/, "Account number must be 9–18 digits"),
  ifscCode: Yup.string()
    .trim()
    .required("IFSC code is required")
    .matches(
      /^[A-Z]{4}0[A-Z0-9]{6}$/,
      "Invalid IFSC code (e.g. SBIN0001234)",
    ),
  bankName: Yup.string()
    .trim()
    .required("Bank name is required")
    .max(255, "Too long"),
  branch: Yup.string()
    .trim()
    .required("Branch is required")
    .max(255, "Too long"),
});

export default bankDetailSchema;
